import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';

import { PermissionData } from '../../api/types';
import { CustomBoxCard } from '../CustomComponents/CustomComponents';
import { LinkWrapper } from '../LinkWrapper/LinkWrapper';

interface AccessPointMissingPermissionItemProps {
    accessPointCode: string;
    permission: PermissionData;
    translations: Record<string, string>;
}

export const AccessPointMissingPermissionItem: React.FC<AccessPointMissingPermissionItemProps> = ({
    accessPointCode,
    permission,
    translations,
}) => (
    <LinkWrapper
        to={`/accesspoint/${accessPointCode}/permissions/${permission.permissionCode}`}
        translations={translations}
    >
        <CustomBoxCard>
            <Grid container alignItems="center">
                <Grid item xs={11} style={{ paddingLeft: '0.2rem' }}>
                    <Typography variant="body1" fontWeight={600}>
                        {permission.permissionCode}
                    </Typography>
                    <Typography color="textSecondary" variant="body2" gutterBottom>
                        {permission.permissionDescription}
                    </Typography>
                </Grid>
                <Grid item xs={1} style={{ textAlign: 'end' }}>
                    <ChevronRightIcon />
                </Grid>
            </Grid>
        </CustomBoxCard>
    </LinkWrapper>
);
